import type { TestDataProps } from "@repo/ui";
import { useTranslation } from "react-i18next";

import DropDownMenu from "@/components/general/drop-down-menu/DropDownMenu";

import { AccountItem } from "../account-item/AccountItem";
import styles from "./AccountSelector.module.css";

import type { SingleValue } from "react-select";
import type { CashierTradingAccountMargin } from "@/api/cashier";

type AccountSelectorProps = {
  accounts: CashierTradingAccountMargin[];
  selectedAccount?: CashierTradingAccountMargin | null;
  onAccountChange: (newAccount: CashierTradingAccountMargin) => void;
  menuOpenDirection?: "left" | "right";
  amountField?: "margin" | "balance";
} & TestDataProps;

export const AccountSelector = ({
  accounts,
  selectedAccount,
  onAccountChange,
  menuOpenDirection,
  amountField = "margin",
  "data-testid": testId,
}: AccountSelectorProps) => {
  const { t } = useTranslation();

  const handleSelectAccount = (
    newAccount: SingleValue<CashierTradingAccountMargin>
  ) => {
    if (newAccount) onAccountChange(newAccount);
  };

  return (
    <DropDownMenu
      data-testid={testId}
      options={accounts}
      selectedOption={selectedAccount}
      onSelectChange={handleSelectAccount}
      menuOpenDirection={menuOpenDirection}
      classNames={{
        option: () => styles["account-selector-option"],
      }}
      optionItemComponent={(account) => (
        <AccountItem
          data-testid={`${testId}-account-item`}
          account={account}
          amountField={amountField}
          active={selectedAccount?.id === account.id}
        />
      )}
      trigger={
        <div className={styles["account-selector-trigger"]}>
          {selectedAccount ? (
            <AccountItem
              data-testid={`${testId}-selected-account`}
              preview
              account={selectedAccount}
            />
          ) : (
            <p>{t("deposit.accounts.select_account")}</p>
          )}
        </div>
      }
    />
  );
};
